import React, { useEffect, useState } from 'react'
import { Spin, Table, Typography } from "antd";
import ModalComponent from '../../../components/modals/ModalComponent';
import { GetInvoiceTemplateApi } from '../../../api/request/invoice';
import toast from 'react-hot-toast';

const { Title, Text, Paragraph } = Typography;

const ViewInvoice = ({ isOpen, setIsOpen, selectedTemplate }) => {
    const [data, setData] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const email = `${process.env.REACT_APP_SITE_NAME}@gmail.com`.toLowerCase();

    const getInvoiceTemplate = async (id) => {
        try {
            setIsLoading(true);
            const { data } = await GetInvoiceTemplateApi({
                invoice_template_id: id,
            });
            if (data.status) setData(data?.data);
        } catch (error) {
            if (error?.response?.data?.message)
                toast.error(error?.response?.data?.message);
        } finally {
            setIsLoading(false);
        }

    };

    useEffect(() => {
        if (selectedTemplate?.id) getInvoiceTemplate(selectedTemplate?.id);
    }, [selectedTemplate?.id]);


    const columns = [
        {
            title: "Title",
            dataIndex: "title",
            key: "title",
        },
        {
            title: "Description",
            dataIndex: "description",
            key: "description",
            align: "center",
            render: (text) => text || "--",
        },
        {
            title: "Charge",
            dataIndex: "charge",
            key: "charge",
            align: "right",
            render: (value) => <Text className="text-green-600 font-bold">${Number(value).toFixed(2)}</Text>,
        },
    ];

    return (

        <ModalComponent isOpen={isOpen} setIsOpen={setIsOpen} width={800} className="top-[50px]">
            {isLoading ? (
                <div className='flex justify-center items-center'>
                    <Spin />
                </div>
            ) : (
                <div className="bg-white h-[700px] overflow-y-auto">
                    <div className="flex justify-between border-b pb-4 mb-4">
                        <Title level={2} className="text-right">
                            Invoice
                        </Title>
                    </div>

                    <div className="mb-4">
                        <Title level={3} className="m-0">
                            KD Tax & Accounting Services
                        </Title>
                        <Text>GST:{data?.admin?.gst_no}</Text>
                        <Paragraph className="m-0 text-gray-600">
                            2300 Yonge Street,<br /> Suite 1600, Toronto,<br /> ON, M4P 1E4
                        </Paragraph>
                        <Text>Phone: {data?.admin?.phone || "--"}</Text>
                        <br />
                        <a href={`mailto:${email}`} className="text-blue-500">
                            {email}
                        </a>
                        <Text className="block text-sm mt-1">HST REG. # 796896900 RT0001</Text>
                    </div>

                    <div className="mb-4">
                        <Text className="font-semibold">TO:</Text>
                        <Paragraph>{data?.admin?.name}</Paragraph>
                    </div>

                    <Text className="text-right block text-gray-600">
                        {
                            data?.created_at?.split("T")[0]
                        }
                    </Text>

                    <div className="my-4">
                        <p><span className='text-base'>Hello,</span> {data?.admin?.name}.</p>
                        <Text className='text-[16px]'>This is your invoice for {data?.name}.</Text>
                    </div>

                    <div className="mb-4">
                        <Title level={4}>Itemized Bill:</Title>
                        <Table
                            dataSource={data?.title ? JSON.parse(data.title) : []}
                            columns={columns}
                            pagination={false}
                            bordered
                        />
                    </div>

                    <div className="text-right text-lg font-bold mt-6">
                        <Text>Total (Incl. Tax): ${Number(data.amount).toFixed(2)}</Text>
                    </div>

                    <Paragraph className="mt-10">
                        You can e-transfer your payment via bank at
                        <a href={`mailto:${email}`} className="text-blue-500 ml-1">
                            {email}
                        </a>
                    </Paragraph>

                    <div className="text-center mt-8 text-gray-500 text-sm">
                        <Text>Thank you for your business!</Text>
                    </div>
                </div>
            )}
        </ModalComponent>

    )
}

export default ViewInvoice
